import { render, staticRenderFns } from "./personUpload.vue?vue&type=template&id=1605879c&scoped=true&"
import script from "./personUpload.vue?vue&type=script&lang=js&"
export * from "./personUpload.vue?vue&type=script&lang=js&"
import style0 from "./personUpload.vue?vue&type=style&index=0&id=1605879c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1605879c",
  null
  
)

export default component.exports